import { Reveal } from "./Reveal";
import { PROCESS_STEPS } from "./data";

export const Process = () => {
  return (
    <section id="process" className="bg-[#093125] py-24 md:py-36" data-testid="process-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <span className="eyebrow text-[#A6874E]">How We Work</span>
        </Reveal>
        <div className="mt-8 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16 md:mb-20">
          <Reveal delay={0.1}>
            <h2
              className="font-grotesk font-bold uppercase text-[#F2EDE1] leading-[0.98] tracking-tight text-4xl sm:text-5xl md:text-6xl"
              data-testid="process-heading"
            >
              A clear path,<br />made together.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="text-xs md:text-sm leading-relaxed text-[#F2EDE1]/55 max-w-xs">
              Momentum comes from shared context and honest decisions. We keep the
              process collaborative, useful and grounded in what you need.
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-12">
          {PROCESS_STEPS.map((step, i) => (
            <Reveal key={step.num} delay={i * 0.1}>
              <div className="border-t border-[#F2EDE1]/20 pt-6" data-testid={`process-step-${step.num}`}>
                <p className="eyebrow mb-8">
                  <span className="text-[#A6874E]">{step.num}</span>
                  <span className="text-[#F2EDE1]/60"> / {step.word}</span>
                </p>
                <h3 className="text-[#F2EDE1] text-lg md:text-xl font-semibold mb-3">{step.title}</h3>
                <p className="text-xs leading-relaxed text-[#F2EDE1]/55">{step.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
